<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import Modal from "../../../../components/modals/modal-form.vue";
import api from '../../../../helpers/apirest/api';

import {
    targetDriverTypeComputed
} from "@/state/helpers";

const initialState = () => {
    return {
        submitted: false,
        target_driver: {
            target_driver_type_id: '',
            name: null,
            key: null,
            secret: null,
            refresh_token: null,
        }
    };
}

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        id: Number
    },
    data() {
        return initialState();
    },
    components: {
        Modal
    },
    computed: {
        ...targetDriverTypeComputed,        
        withKey(){
            const allowDrivers = ['bigquery'];
            return this.forTargetDriverType(allowDrivers);            
        },
        withSecret(){
            const allowDrivers = ['bigquery'];
            return this.forTargetDriverType(allowDrivers);            
        },        
        withRefreshToken(){
            const allowDrivers = ['bigquery'];
            return this.forTargetDriverType(allowDrivers);            
        },
    },
    validations: {
        target_driver: {

            target_driver_type_id: { required },
            name: { required },            
            key: {
                required: requiredIf(function() { 
                    return this.withKey
                }),
            },
            secret: {
                required: requiredIf(function() { 
                    return this.withSecret
                }),
            },            
            refresh_token: {
                required: requiredIf(function() { 
                    return this.withRefreshToken
                }),
            },
        }
    },
    methods: {
        forTargetDriverType(allowDrivers){
            if(this.targetDriverTypes && this.target_driver?.target_driver_type_id){
                const selectedDriverType = this.targetDriverTypes.find(item => item.id === this.target_driver?.target_driver_type_id)
                if(selectedDriverType && allowDrivers.includes(selectedDriverType?.slug)){
                    return true;
                }
            }
            return false;
        },
        async shown() {

            this.$store.dispatch("targetDriverType/loadList");

            if (this.id) {
                const response = await api.get({
                    url: `target-drivers/${this.id}`
                });
                this.target_driver = response?.data?.data;
            }
        },
        async confirm() {

            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            const data = this.target_driver;

            await api.save({
                url: 'target-drivers',
                id: this.target_driver?.id,
                data: data 
            });

            this.$bvModal.hide(this.modalId);
            this.$emit("onSuccess");
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        resetModal() {
            Object.assign(this.$data, initialState());
        }
    }
};
</script>

<template>
    <Modal :title="'Custom title'" :id="modalId" @confirm="confirm" @cancel="cancel" @shown="shown" @hidden="resetModal">
        <div class="form-group">
            <label for="target_driver_type_id">Target Driver Type</label>
            <select v-model="target_driver.target_driver_type_id" class="form-control"
                :class="{ 'is-invalid': $v.target_driver.target_driver_type_id.$error && submitted }">
                <option value="">Select</option>
                <option v-for="option in targetDriverTypes" v-bind:value="option.id" :key="option.id">
                    {{ option.name }}
                </option>
            </select>
            <div v-if="!$v.target_driver.target_driver_type_id.required && submitted" class="invalid-feedback">Target Driver Type is
                required</div>
        </div>
        <div class="form-group">
            <label for="name">Name</label>
            <input id="name" v-model="target_driver.name" type="text" class="form-control" placeholder="Enter name"
                :class="{ 'is-invalid': $v.target_driver.name.$error && submitted }" />
            <div v-if="!$v.target_driver.name.required && submitted" class="invalid-feedback">Name is required</div>
        </div>
        
        <div class="form-group" v-if="withKey">
            <label for="key">Key</label>
            <input id="key" v-model="target_driver.key" type="key" class="form-control" placeholder="Enter key"
                :class="{ 'is-invalid': $v.target_driver.key.$error && submitted }" />
            <div v-if="!$v.target_driver.key.required && submitted" class="invalid-feedback">Key is required</div>
        </div>
        <div class="form-group" v-if="withSecret">
            <label for="secret">Secret</label>
            <input id="secret" v-model="target_driver.secret" type="secret" class="form-control" placeholder="Enter secret"
                :class="{ 'is-invalid': $v.target_driver.secret.$error && submitted }" />
            <div v-if="!$v.target_driver.secret.required && submitted" class="invalid-feedback">Secret is required</div>
        </div>
        
        <div class="form-group" v-if="withRefreshToken">
            <label for="refresh_token">RefreshToken</label>
            <input id="refresh_token" v-model="target_driver.refresh_token" type="refresh_token" class="form-control" placeholder="Enter refresh_token"
                :class="{ 'is-invalid': $v.target_driver.refresh_token.$error && submitted }" />
            <div v-if="!$v.target_driver.refresh_token.required && submitted" class="invalid-feedback">Refresh Token is required</div>
        </div>
    </Modal>
</template>